/*global Modernizr, Splide, TLASlideCurrentSlide, TLASlideHideArrows, TLASlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var testimonial_sliders = document.querySelectorAll('.testimonial-slider');
    if(testimonial_sliders) {
      testimonial_sliders.forEach((testimonial_slider) => {
        const slider = new Splide(testimonial_slider, {
          type: 'loop',
          pagination: false
        });

        slider.on('mounted resize', () => {
          if(slider.length <= slider.options.perPage) {
            slider.root.querySelector('.splide__arrows').classList.add('page-less');
          } else {
            slider.root.querySelector('.splide__arrows').classList.remove('page-less');
          }
        });

        slider.mount({ TLASlideCurrentSlide, TLASlideDisableDrag });
      });
    }
}());
